// extracted by mini-css-extract-plugin
export default {"all-resources":"S0G8kr","all-resources__title":"wxkhBZ","all-resources__grid":"Qy8fcP","all-resources__card":"ehzryx","all-resources__button-wrapper":"gVqQ65"};